"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Table = {
  defaultProps: {
    border: "none"
  },
  styles: function styles(theme) {
    return {
      table: {
        "& th": {
          background: "none"
        }
      },
      striped: {
        "& tr": {
          "&:nth-child(even)": {
            "&:hover": {
              background: theme.colors.baseContrast030
            }
          }
        }
      },
      thead: {
        "& th": {
          background: "none",
          borderBottom: "1px solid",
          borderBottomColor: theme.colors.baseContrast020,
          fontSize: theme.typography.fontSize + 2
        }
      },
      tbody: {
        fontSize: theme.typography.fontSize,
        "& td": {
          fontSize: theme.typography.fontSize
        }
      },
      sortIndicator: {
        margin: "1.2px 6px",
        // spacing around each sort arrow - top/bottom and left/right
        borderWidth: 4,
        // increase to make sort arrows wider
        borderBottomWidth: 4,
        // increase to make sort arrows taller
        borderBottomColor: theme.colors.baseContrast050 // sort arrows color
      },
      activeSortIndicator: {
        borderBottomColor: theme.colors.baseContrast070 // sort arrows color indicating sort direction
      }
    };
  }
};
var _default = exports.default = Table;